
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpService} from '../http-service.service';
import {Observable} from 'rxjs';
import {ApiConst} from '../api-const';
import {WorkflowTargetState} from '../../../model/workflow-target-state.enum';
import {StorageService} from '../../storage/storage.service';

/**
 * Service that handle workflow request, like getting list of workflows, list of fold of a certain space...
 */
@Injectable()
export class WorkflowService {

  /**
   * Default constructor, do nothing
   *
   * @param {HttpService} httpService - handle http Request
   */
  constructor(private httpService: HttpService, private storageService: StorageService) {

  }

  /**
   * get the list of existing workflows
   * @return {Observable<any[]>}
   */
  public getlistOfWorkflows(): Observable<any[]> {
    return this.httpService.$post(ApiConst.getListOfWorkflows, '' ).pipe(map(response => {
      return response.body.listObjWfCriteria;
    }));
  }

  /**
   * get folds of a certain space
   * @param {string} spaceName - name of the workflow
   * @return {Observable<any>} - the list of fold
   */
  public getListOfFoldsBySpaceName(spaceName: string): Observable<any> {

    const dataToSend = JSON.stringify({
      spaceName: spaceName
    });

    return this.httpService.$post(ApiConst.getWorkflowfSpaceFolds, dataToSend).pipe(map(response => {
      return response.body.listObjWfFold;
    }));
  }

  /**
   * function tha handle accepting folds
   * @param {any[]} folds - list of folds that the user wants to accept
   * @param {string} spaceName - selected workflow
   * @return {Observable<any>} - return true if the request succeed
   */
  public acceptListOfFolds(folds: any[], spaceName: string, emailList: string[]): Observable<any> {
    const dataToSend = {
      sNextNameWfSpace: spaceName,
      listObjWfFold: this.addStateforFolds(folds, WorkflowTargetState.ACCEPT)
    };
    if (emailList) {
      dataToSend['emailList'] = emailList;
    }
    return this.httpService.$post(ApiConst.updateWorkflowFolds, JSON.stringify(dataToSend)).pipe(map(response => {
      return response;
    }));
  }

  /**
   * function tha handle rejecting folds
   *
   * @param {any[]} folds - list of folds that the user wants to accept
   * @param {string} spaceName - selected workflow
   * @param {string} refusalReason - reason seized by user (can be empty)
   * @return {Observable<any>} - return true if the request succeed
   */
  public rejectListOfFolds(folds: any[], spaceName: string, emailList: string[], refusalReason: string): Observable<any> {
    const dataToSend = {
      sNextNameWfSpace: spaceName,
      listObjWfFold: this.addRefusalReason(this.addStateforFolds(folds, WorkflowTargetState.REFUSE), refusalReason)
    };
    if (emailList) {
      dataToSend['emailList'] = emailList;
    }
    return this.httpService.$post(ApiConst.updateWorkflowFolds, JSON.stringify(dataToSend)).pipe(map(response => {
      return response;
    }));
  }

  /**
   * function tha handle retrying folds
   *
   * @param {any[]} folds - list of folds that the user wants to accept
   * @param {string} spaceName - selected workflow
   * @return {Observable<any>} - return true if the request succeed
   */
  public retryListOfFolds(folds: any[], spaceName: string): Observable<any> {
    const dataToSend = JSON.stringify({
      sNextNameWfSpace: spaceName,
      listObjWfFold: this.addStateforFolds(folds, WorkflowTargetState.RETREAT)
    });

    return this.httpService.$post(ApiConst.updateWorkflowFolds, dataToSend).pipe(map(response => {
      return response.body.bOK;
    }));
  }

  /**
   * Function that alter fold list by adding the targetState (see WorkflowTargetState)
   * @param {any[]} folds - list of folds
   * @param {string} targetState - the targetState
   * @return {any[]} - the list of altered folds
   */
  private addStateforFolds(folds: any[], targetState: string): any[] {
    const modifiedFolds = [];
    for (const fold of folds) {
      fold.targetstate = targetState;
      fold.creatuser = this.storageService.getCurrentUserInStorage().idUser;
      fold.sUserID = this.storageService.getCurrentUserInStorage().idUser;
      modifiedFolds.push(fold);
    }
    return modifiedFolds;
  }

  /**
   * Function that alter fold list by adding the refusalReason
   * @param {any[]} folds - list of folds
   * @param {string} refusalReason - Reason of the reject
   * @return {any[]} - the list of altered folds
   */
  private addRefusalReason(folds: any[], refusalReason: string): any[] {
    const modifiedFolds = [];
    for (const fold of folds) {
      fold.refusalreason = refusalReason;
      modifiedFolds.push(fold);
    }
    return modifiedFolds;
  }

}
